import React from "react"

import { Box } from "components"

const Flex = ({ ...props }) => (
  <Box data-component-id="💪" display="flex" {...props} />
)

export default Flex
